const ViewBlock = ({ title, content }) => (
  <div className="viewBlock">
    <div className="titleInput">{title}</div>
    <div className="contentInput">{content}</div>
  </div>
);

export default ViewBlock;
